import { ListRequestModel } from 'app/api/models/list-request.model';
import { SortOrder } from 'app/shared/models/sort-order.model';
import { Filter } from 'app/shared/models/filter.model';
import { LookupList } from 'app/shared/models/lookup-list.model';
export class CaseListRequestModel extends ListRequestModel {
  constructor(
    public nameOrReference: string = '',
    paged: boolean = true,
    pageNumber: number = 1,
    pageSize: number = 20,
    sort: Array<SortOrder> = [],
    filters: Array<Filter> = [],
    public caseStatus: number = null,
    public caseType: string = '',
    public caseStatusLookupData: LookupList = null,
    public caseTypeLookupData: LookupList = null
  ) {
    super(paged, pageNumber, pageSize, sort, filters);
  }
}
